const IlhaPerfil = ({ children }: { children?: React.ReactNode }) => {

    return (
        <div className="border !p-2 border-gray-200 rounded-lg flex flex-col">
            {children}
        </div>
    )
};

export default IlhaPerfil